import React from "react";

export default function NavbarLower() {
  return (
    <ul className="lower__container">
      <li className="list__item">Customer Service</li>
      <li className="list__item">Best Sellers</li>
      <li className="list__item">Amzin Basics</li>
      <li className="list__item">Today's Deals</li>
      <li className="list__item">Dime</li>
      <li className="list__item">New Releases</li>
      <li className="list__item">Books</li>
      <li className="list__item">Music</li>
      <li className="list__item">Gift Cards</li>
      <li className="list__item">Registry</li>
      <li className="list__item">Fashion</li>
      <li className="list__item">Amzin Home</li>
      <li className="list__item">Toys & Games</li>
      <li className="list__item">Pharmacy</li>
      <li className="list__item">Coupons</li>
      <li className="list__item">Sell</li>
      <li className="list__item">Computers</li>
      <li className="list__item">Video Games</li>
      <li className="list__item">Automotive</li>
      <li className="list__item">Home Improvement</li>
      <li className="list__item">Beauty & Personal Care</li>
      <li className="list__item">Smart Home</li>
      <li className="list__item">Pet Supplies</li>
      <li className="list__item">Luxury Stores</li>
    </ul>
  );
}
